import { css } from '@emotion/css';

export const widthHandlerStyles = css`
  top: 50%;
  transform: translateY(-50%);
`;

export const heightHandlerStyles = css`
  left: 50%;
  transform: translateX(-50%);
`;

export const resizeHandleStyles = css`
  background: rgba(15, 15, 15, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.9);
`;

export const nodeWidth = (width: number) => css`
  width: ${width}px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

// There is extra left padding of 30px in the ProseMirror class. So we need to adjust the
// container considering the extra padding. We are putting logic at one place and using it while
// setting the node container style when moving the mouse.
export const nodeContainerStyles = (width: number) => ({
  width: `${width}px`,
  marginLeft: `${(width / 2) * -1}px`,
  marginRight: `${(width / 2) * -1}px`,
});

export const nodeContainerStylesMobile = () => ({
  //padding of 20px on both sides
  width: `100%`,
  marginLeft: `0px`,
  marginRight: `0px`,
});

export const nodeContainerWidth = (width: number) => css`
  ${nodeContainerStyles(width)}
  @media (max-width: 767px) {
    ${nodeContainerStylesMobile()}
  }
`;

export const allTransition = css`
  -webkit-transition: all 50ms ease-in-out;
  -moz-transition: all 50ms ease-in-out;
  -o-transition: all 50ms ease-in-out;
  transition: all 50ms ease-in-out;
`;

export const hotspotStyle = (top: number, left: number) => css`
  background: rgba(0, 0, 0, 0.4);
  top: ${top}px;
  left: ${left}px;
`;

export const hotspotNumberText = css`
  line-height: 2rem;
`;

export const popoverSize = css`
  width: 28rem;
  height: 12rem;
`;

export const editableHotspotCursor = css`
  cursor:
    url(data:image/svg+xml;base64,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)
      40 25,
    auto;
`;
